<div class="pie_chart"> 
    <h2>{{chart.Title}}</h2>
    <div *ngIf="allFieldsEmpty">
        {{ chartDescription }}
    </div>
    <canvas
        baseChart
        [data]="pieChartData"
        [options]="options"
        [type]="pieChartType"
        [plugins]="[ChartDataLabels]">
    </canvas>
</div>
  